module.exports = __webpack_public_path__ + "img/alt8.6ed5be4b.jpg";